<template>
  <div class="main bar-chart avoid-page-break">
    <div class="title">
    </div>
    <div :id="`tester-${graph_data.trace1.name}`">
    </div>
  </div>
</template>
<script>
import Plotly from 'plotly.js/lib/index-basic';
var layout = {
  // showlegend: false,
  hovermode: false,
  autosize: false,
  width: 768,
  height: 400,
  bargap: 0.3,
  bargroupgap: 0.3,
  type: 'bar',
  legend: {
    x: 0.8,
    y: 100,
    traceorder:'normal',
    bgcolor:'white',
  },
  margin: {
    l: 100, r: 100, b: 50, t: 50, pad: 0, autoexpand:true,
  },
  font: {
    size:10,
  },
  title: '',
  size:'0.5',
  paper_bgcolor: 'white',
  plot_bgcolor: 'white',
  ticks :'',
  yaxis: {
    fixedrange: true,
    showticklabels:false,
    scaleratio:1,
    tickformat: ',.0%',
    range: [-0.72,0.71]
  },
  xaxis: {
    fixedrange: true,
  },
};
export default {
  name: 'BarChartComponent',
  props: {
    graph_data:Object,
    assetClassColor: String
  },
  data() {
    return {
      title:String,
      yValue:[],
      trace1: { x: [], y: [], text: [],
        textposition: 'outside',
        name: '',
        type: 'bar',
        marker: {
          color: '#FFB54F',
        }
      },
      trace2: { x: [], y: [], text: [],
        textposition: 'outside',
        name: 'Benchmark',
        type: 'bar',
        marker: {
          color: '#B7B7B7',
        }
      },
    }
  },
  computed:{
    output(){
      return [ this.trace1, this.trace2 ]
    }
  },
  watch:{
    graph_data: function (value) {
      this.data = this.graph_data;
      this.title = this.graph_data.tittle,
      this.trace1.marker.color = this.assetClassColor
      this.transformData(this.trace1,this.data.trace1);
      this.transformData(this.trace2,this.data.trace2);
      this.displayGraph();
    }
  },
  methods: {
    transformData(key,trace){
      key.y = trace.data;
      key.text = this.transformTopercentage(trace.data);
      key.x = this.data.dates;
      key.name = trace.name;
    },
    transformTopercentage(data) {
      return data.map(function(d){
        // num is multiplied for 1000 an the divided between 10 to aviod js bugs
        let num =  (d * 1000)/10;
        if ( num % 1 != 0 ){ num = num.toFixed(2)  }
        return (num) + '%'
      });
    },
    displayGraph() {
      const container = document.getElementById(`tester-${this.graph_data.trace1.name}`);
      Plotly.newPlot(container,
        this.output,
        layout,
        {displayModeBar: false},
      );
    },
  },
}
</script>
<style lang="css" scoped>

.bar-chart {
  display: block;
  margin: 0 auto;
  max-width: 768px;
}

.title {
  max-width: 768px;
  display: block;
  margin: 0 auto;
  z-index: 10;
  height: 1px;
}

.title p {
  position: relative;
  top: 16px;
  margin-left: 100px;
  font-size: 20px;
  font-weight: 900;
  z-index: 10;
}

</style>
<style media="screen">

.svg-container {
  display: block;
  margin: 0 auto !important;
}

</style>



// WEBPACK FOOTER //
// src/components/BarChart.vue